<div
  class="il-loader"
  [class.il-loader--inline]="!overlay()"
  [class.il-loader--background]="background()"
  aria-live="polite">
  <div class="il-loader__card">
    <div class="il-loader__logo-wrap" aria-hidden="true">
      <img src="./holcim-favicon.png" alt="Holcim" class="il-loader__favicon" />
    </div>

    <div class="il-loader__title">{{ title() | safeLabel }}</div>

    <div class="il-loader__stage">
      <span>{{ displayStage() | safeLabel }}</span>
      @if (background()) {
      <span class="il-loader__sync"><i class="pi pi-sync pi-spin"></i> syncing in background</span>
      }
    </div>

    @if (showProgress()) {
    <div class="il-loader__progress">
      <span class="il-loader__progress-track">
        <span class="il-loader__progress-fill" [style.width.%]="fillPct()"></span>
      </span>
      <span class="il-loader__progress-text">Part {{ progressPart() }} of {{ progressTotal() }}</span>
    </div>
    } @else {
    <div class="il-loader__track" aria-hidden="true">
      <span class="il-loader__track-fill"></span>
    </div>
    }

    <div class="il-loader__skeleton" aria-hidden="true">
      @for (i of rowIndexes(); track i) {
      @if (rowVariant() === 'rich') {
      <div class="il-loader__row il-loader__row--rich">
        <span class="il-loader__block il-loader__block--avatar"></span>
        <span class="il-loader__block il-loader__block--line"></span>
        <span class="il-loader__block il-loader__block--line il-loader__block--line-short"></span>
        <span class="il-loader__block il-loader__block--line il-loader__block--line-tiny"></span>
      </div>
      } @else {
      <div class="il-loader__row il-loader__row--plain"></div>
      }
      }
    </div>
  </div>
</div>